/** Flip to true when we're ready to show the business phone again. */
export const UPCARET_BUSINESS_PHONE_VISIBLE = false;

/** E.164 without the `tel:` prefix — use for JSON-LD and tel: links */
export const UPCARET_BUSINESS_PHONE_E164 = '+14026193131';

export const UPCARET_BUSINESS_PHONE_TEL = `tel:${UPCARET_BUSINESS_PHONE_E164}`;

export const UPCARET_BUSINESS_PHONE_DISPLAY = '(402) 619-3131';
